import * as ko from "knockout";
import Bao from "./../../services/bao-service";
// bao migrate - module not found: import "services/bao-template-engine";
import "./../../bindings/bao-date-time-box";
import "./../../bindings/bao-date-time-picker";
import "./../../bindings/bao-searcher";
function ExpandedSearchShiftPlanMinRequired(parent) {
    var self = this;
    var htmlUrl = "ExpandedSearchSynoset/ExpandedShiftPlanMinRequired";
    self.LoadHtml = function () {
        return Bao.get(htmlUrl, function (result) {
            Bao.Templates[htmlUrl] = result;
            parent.ExpandedSearchTemplateName(htmlUrl);
        });
    };
    self.WorkplaceId = ko.observable();
    self.WorkplaceName = ko.observable();
    self.WorkplaceId.subscribe(function () {
        parent.CustomFilter(self.GetCustomFilter());
    });
    self.ShiftBookId = ko.observable();
    self.ShiftbookName = ko.observable();
    self.ShiftBookId.subscribe(function () {
        parent.CustomFilter(self.GetCustomFilter());
    });
    self.ShiftTypeId = ko.observable();
    self.ShiftTypeName = ko.observable();
    self.ShiftTypeId.subscribe(function () {
        parent.CustomFilter(self.GetCustomFilter());
    });
    self.StartFromDate = ko.observable();
    self.StartFromDate.subscribe(function () {
        parent.CustomFilter(self.GetCustomFilter());
    });
    self.StartToDate = ko.observable();
    self.StartToDate.subscribe(function () {
        parent.CustomFilter(self.GetCustomFilter());
    });
    self.EndFromDate = ko.observable();
    self.EndFromDate.subscribe(function () {
        parent.CustomFilter(self.GetCustomFilter());
    });
    self.EndToDate = ko.observable();
    self.EndToDate.subscribe(function () {
        parent.CustomFilter(self.GetCustomFilter());
    });
    self.GetCustomFilter = function () {
        if (self.WorkplaceId() == null && self.ShiftBookId() == null && self.ShiftTypeId() == null
            && self.StartFromDate() == null && self.StartToDate() == null && self.EndFromDate() == null && self.EndToDate() == null) {
            return null;
        }
        else {
            return {
                WorkplaceId: JSON.stringify(self.WorkplaceId()),
                ShiftBookId: JSON.stringify(self.ShiftBookId()),
                ShiftTypeId: JSON.stringify(self.ShiftTypeId()),
                StartFromDate: self.StartFromDate(),
                StartToDate: self.StartToDate(),
                EndFromDate: self.EndFromDate(),
                EndToDate: self.EndToDate(),
            };
        }
    };
    self.init = function () {
        return self.LoadHtml();
    };
}
export default ExpandedSearchShiftPlanMinRequired;